import { EAddressVerifiedStatus } from 'v2/shared/contact/address-verified-status.const';
import { IAddressContact } from 'v2/shared/contact/address.interface';

import { IOrderSalesShipstationAddress } from '../../order/interfaces/order-picklist-preview';

export enum EShippingStatus {
  PENDING = 'PENDING',
  SHIPPING = 'SHIPPING',
  SHIPPED = 'SHIPPED',
  FAILED = 'FAILED',
}

export enum EPackingSlipPageSize {
  A4 = 'A4',
  A6 = 'A6',
}

// USED IN FACADE IMPLEMENTATION
export interface IWeightUnit {
  units :string;
  value :number;
}

export interface IShippingLabelOrderLineItemWeight {
  pounds :IWeightUnit;
  ounces :IWeightUnit;
}

export interface IShippingLabelOrderLineItemDimension {
  units :string;
  length :number;
  width :number;
  height :number;
}

export interface IShippingItem {
  salesOrderId :number;
  orderNumber :string;
  carrierCode :string;
  serviceCode :string;
  packageCode :string;
  weight :IShippingLabelOrderLineItemWeight;
  dimensions :IShippingLabelOrderLineItemDimension;
  confirmation :string;
  shipTo :IOrderSalesShipstationAddress | null;
  shipFrom :IOrderSalesShipstationAddress | null;
  // UI ONLY
  shipToString :string;
  selected :boolean;
  dimensionsUnitString ?:string;
  orderItemsCount :number;
  shipRate :number;
  shipRateLoading :boolean;
}

export interface IShippingCarrier {
  id :number;
  name :string;
  code :string;
}

export interface IShippingCarrierPackageService {
  id :number;
  carrierCode :string;
  code :string;
  name :string;
  domestic :boolean;
  international :boolean;
}

export interface IShippingCarrierService extends IShippingCarrierPackageService {
  carrierServiceId :string;
  rate ?:number;
}

export interface IShippingCarrierPackage extends IShippingCarrierPackageService {
  carrierPackageId :string;
}
